module.exports = __webpack_public_path__ + "h5/img/languan_footer.44e88d5c.png";